<script setup lang="ts">
import { Book, BookOpen, BookUser, FolderOpen, HardDrive, Users } from 'lucide-vue-next'
import { RouterLink } from 'vue-router'
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import { useSidebar } from '@/components/ui/sidebar/useSidebar'

const { setOpen } = useSidebar()

const userItems = [
  {
    title: 'Accounts',
    icon: Users,
    href: '/admin/accounts',
  },
  {
    title: 'Devices',
    icon: HardDrive,
    href: '/admin/devices',
  },
]

const booksItems = [
  {
    title: 'Books',
    icon: Book,
    href: '/admin/books',
  },
  {
    title: 'Authors',
    icon: BookUser,
    href: '/admin/authors',
  },
  {
    title: 'Categories',
    icon: FolderOpen,
    href: '/admin/categories',
  },
]

const activityItems = [
  {
    title: 'Readings',
    icon: BookOpen,
    href: '/admin/readings',
  },
]

const MOBILE_BREAKPOINT = 768

function handleNavClick(): void {
  if (typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT) {
    setOpen(false)
  }
}
</script>

<template>
  <SidebarGroup>
    <SidebarGroupLabel>Users</SidebarGroupLabel>
    <SidebarGroupContent>
      <SidebarMenu>
        <SidebarMenuItem v-for="item in userItems" :key="item.href">
          <RouterLink v-slot="{ isActive }" :to="item.href" @click="handleNavClick">
            <SidebarMenuButton :is-active="isActive">
              <component :is="item.icon" />
              <span>{{ item.title }}</span>
            </SidebarMenuButton>
          </RouterLink>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroupContent>
  </SidebarGroup>

  <SidebarGroup>
    <SidebarGroupLabel>Books</SidebarGroupLabel>
    <SidebarGroupContent>
      <SidebarMenu>
        <SidebarMenuItem v-for="item in booksItems" :key="item.href">
          <RouterLink v-slot="{ isActive }" :to="item.href" @click="handleNavClick">
            <SidebarMenuButton :is-active="isActive">
              <component :is="item.icon" />
              <span>{{ item.title }}</span>
            </SidebarMenuButton>
          </RouterLink>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroupContent>
  </SidebarGroup>

  <SidebarGroup>
    <SidebarGroupLabel>Activity</SidebarGroupLabel>
    <SidebarGroupContent>
      <SidebarMenu>
        <SidebarMenuItem v-for="item in activityItems" :key="item.href">
          <RouterLink v-slot="{ isActive }" :to="item.href" @click="handleNavClick">
            <SidebarMenuButton :is-active="isActive">
              <component :is="item.icon" />
              <span>{{ item.title }}</span>
            </SidebarMenuButton>
          </RouterLink>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroupContent>
  </SidebarGroup>
</template>
